export default __webpack_public_path__ + "static/media/No15.f9f4f483.jpeg";